var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "reconciliation-step-template",
    {
      attrs: {
        nextStep: _vm.nextStep,
        previousStep: _vm.previousStep,
        loading: _vm.loading
      },
      on: {
        next: _vm.goToNextStep,
        previous: function($event) {
          return _vm.$emit("previous")
        }
      }
    },
    [
      _c("template", { slot: "content" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Libéllé de la transaction")))]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
          _vm._v(
            _vm._s(
              _vm.$l10n.__(
                "Vous pouvez définir une ou plusieurs colonnes qui définiront le libellé."
              )
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "step-container-table border-black mt-3"
          },
          [
            _c("table-selectable-columns", {
              attrs: { lines: _vm.csv, max: 3 },
              model: {
                value: _vm.value.template.label.columns,
                callback: function($$v) {
                  _vm.$set(_vm.value.template.label, "columns", $$v)
                },
                expression: "value.template.label.columns"
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }